import { SelectSettings } from './types';
import { Theme } from '../../../themeBase';

export const selectSettings: SelectSettings = {
  componentVariants: {
    selectVariant: {
      prop: 'selectVariant',
      variants: {
        primary: {
          fontWeight: 0,
          fontFamily: 'secondary',
          color: 'black.main',
          backgroundColor: 'white.main',
          boxShadow: (props: Theme) => props.boxShadows.input,
          '&::placeholder': {
            color: 'gray.main',
          },
        },
        secondary: {
          fontWeight: 600,
          fontFamily: 'secondary',
          color: 'black.main',
          backgroundColor: 'white.main',
          boxShadow: 'none',
          '&::placeholder': {
            color: 'gray.main',
          },
        },
      },
    },
    borderVariant: {
      prop: 'borderVariant',
      variants: {
        primary: {
          borderColor: 'gray.light',
          borderRadius: 3,
        },
      },
    },
    dropdownVariant: {
      prop: 'dropdownVariant',
      variants: {
        primary: {
          color: 'gray.main',
        },
        secondary: {
          color: 'black.main',
        },
      },
    },
    selectSize: {
      prop: 'selectSize',
      variants: {
        small: {
          fontSize: '0',
          lineHeight: '0',
          paddingTop: 2,
          paddingRight: 4,
          paddingBottom: 2,
          paddingLeft: 4,
        },
        medium: {
          fontSize: '1',
          lineHeight: '1',
          paddingTop: 3,
          paddingRight: 5,
          paddingBottom: 3,
          paddingLeft: 5,
        },
      },
    },
    status: {
      prop: 'status',
      variants: {
        disabled: {
          cursor: 'not-allowed',
          borderColor: 'gray.light',
          backgroundColor: 'white.dark',
          color: 'gray.main',
          boxShadow: 'none',
          '&:hover, &:active, &:focus, &:focus-visible': {
            borderColor: 'gray.light',
            backgroundColor: 'white.dark',
          },
        },
        error: {
          borderColor: 'danger.main',
          boxShadow: 'none',
          '&:hover, &:active, &:focus, &:focus-visible': {
            borderColor: 'danger.main',
            backgroundColor: 'white.main',
          },
        },
        active: {
          '&:hover, &:active, &:focus, &:focus-visible': {
            borderColor: 'primary.main',
            backgroundColor: 'primary.extraLight',
            outline: 'none',
            boxShadow: 'none',
          },
        },
      },
    },
  },
};
